import { useCallback, useState } from 'react'
import { apiGet } from '../../../../generic/Api_Functions'

// Story 100 (S100/S104, RN47/DN-7): the "Returned" population is the widget's history -- it is the
// one population Sun paginates server-side (S104 wires the period filter and the page control on
// top of this hook; here it only fetches page 0, laying the groundwork). Contract (convergence,
// lote 17/lote 15-16): `GET mos/externalJob/returned?from&page&size` (query params, NOT a POST body
// -- a plant 405 exposed the earlier assumption), responding with a Spring `Page`
// (`{ content, totalElements }`).
export const RETURNED_RESOURCE = 'mos/externalJob/returned'
export const DEFAULT_PAGE_SIZE = 10

const useReturnedExternalJobTrips = () => {
  const [rows, setRows] = useState([])
  const [totalElements, setTotalElements] = useState(0)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const reload = useCallback(async (request = {}) => {
    setLoading(true)
    try {
      const page = await apiGet(RETURNED_RESOURCE, { page: 0, size: DEFAULT_PAGE_SIZE, ...request })
      setRows(Array.isArray(page?.content) ? page.content : [])
      setTotalElements(page?.totalElements ?? 0)
      setError(null)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  return { rows, totalElements, loading, error, reload }
}

export default useReturnedExternalJobTrips
